<template>
	<!-- 上架产品详情页 -->
	<div class="sjcp">
		<cube-page title="上架产品">
			<div slot="content">
				<div class="spitem" v-if="'goods_name' in goods">
					<div class="leftimg">
						<img :src="goods.images">
					</div>
					<div class="right-content">
						<div class="title ells2">
							{{goods.goods_name}}
						</div>
						<div class="xse" style="overflow: hidden;">
							<p class="ells" v-for="desc in goods.describe.split('<br/>')">
								{{desc}}
							</p>
						</div>
						<div class="xse" style="display: flex;justify-content: space-between;">
							<div class="l">
								销量:{{goods.sales_actual}}
							</div>
							<div class="r">
								价格:{{goods.goods_price}}起
							</div>
						</div>
					</div>

				</div>
				<div class="listjg">
					<van-field style="font-weight: 600;font-size: 15px;"
					v-model="sort" label="排序设置" placeholder="值越大,权重越高" />
					<div class="jgtitle">
						价格设置
					</div>
					<van-cell-group class="jgitem" v-for="(item,index) in goodsskus" :key="index">
						<van-cell title="约赚？元" :value="item.sku_name" :label="item.add_price" />
<!--						<van-cell title="底价" :value="item.floor_price" />-->
            <!--<van-cell title="加价金额(即利润)" v-if="item.add_price==''">
              &lt;!&ndash; 使用 right-icon 插槽来自定义右侧图标 &ndash;&gt;
              <template #default>
                <van-field v-model="item.jj" type="number" input-align="right" placeholder="请输入调整价格"
                  @input="fieldJjupdate" @click-input="fieldJjfocus(item,index)" />
              </template>
            </van-cell>-->
<!--						<van-cell v-else is-link title="加价金额(即利润)">
							&lt;!&ndash; 使用 right-icon 插槽来自定义右侧图标 &ndash;&gt;
							<template #default>
								<van-popover v-model="showPopover[index]" theme="dark" trigger="click"
									placement="bottom-end" @open="openPopover(item,index)" :actions="actionsPopover"
									@select="selectPopover">
									<template #reference>
										<span>{{item.jj}}</span>
									</template>
								</van-popover>
							</template>
						</van-cell>-->
						<!-- <van-cell title="售价" :value="item.sj" /> -->
					</van-cell-group>
				</div>
				<!-- <van-action-sheet v-model="show" :actions="actions" @select="onSelect" cancel-text="取消" title="请选择价格"
					close-on-click-action /> -->

				<van-goods-action>
					<van-goods-action-button type="danger" text="
				上架产品" @click="goSjcp" />
				</van-goods-action>
			</div>
		</cube-page>
	</div>
</template>

<script>
	import CubePage from '../TP/cube-page.vue'
	import * as util from '@/utils/network'
	import {
		Dialog,
		Toast
	} from 'vant';
	export default {
		components: {
			CubePage,
		},
		data() {
			return {
				store: null,
				number: '',
				value: '请选择',
				isxz: true,
				show: false,
				goodsid: this.$route.query.goods_id,
				goods: {},
				goodsskus: [],
				actions: [],
				selectItem: {},
				selectIndex: 0,
				showPopover: [],
				actionsPopover: [],
				sort: ''
			}
		},
		methods: {
			clerNum(e, type) {
				const obj = e.target
				obj.value = obj.value.replace(/[^\d.]/g, '') // 清除“数字”和“.”以外的字符
				obj.value = obj.value.replace(/\.{2,}/g, '.') // 只保留第一个. 清除多余的
				obj.value = obj.value.replace('.', '$#$').replace(/\./g, '').replace('$#$', '.')
				obj.value = obj.value.replace(/^(\-)*(\d+)\.(\d).*$/, '$1$2.$3') // 只能输入1个小数
				if (obj.value.indexOf('.') < 0 && obj.value != '') { // 以上已经过滤，此处控制的是如果没有小数点，首位不能为类似于 01、02的金额
					obj.value = parseFloat(obj.value)
				}
				this[type] = obj.value
			},
			openPopover(item, i) {
				this.actionsPopover = []
				this.selectIndex = i
				let arr = item.add_price.split(',');
				for (var i = 0; i < arr.length; i++) {
					this.actionsPopover.push({
						text: arr[i] * 1
					})
				}
				this.selectItem = item;
			},
			selectPopover(v) {
				let that = this
				if (v.text != '') {
					that.selectItem.jj = v.text
					that.goodsskus.splice(that.selectIndex, 1, that.selectItem)
				}
			},
			// 价格输入框,获取焦点时 获取当前修改对象
			fieldJjfocus(item, i) {
				this.selectIndex = i
				this.selectItem = item;
			},
			// 价格输入框,失去焦点时 计算价格
			fieldJjupdate(v) {
				let that = this
				if ('sku_name' in that.selectItem) {
					if (v.length > 0) {
						that.selectItem.jj = v
						that.goodsskus.splice(that.selectIndex, 1, that.selectItem)
					}
				}
			},
			// 计算售价
			jsSj(item) {
				let that = this
				for (var i = 0; i < that.list.length; i++) {
					if (item.pname == that.list[i].pname) {
						that.list[i].sj = (parseInt(that.list[i].price) + parseInt(item.jj)).toFixed(2);
						return;
					}
				}
			},
			goSjcp() {
				let that = this
				let sku = []
				let num = 0
				that.goodsskus.map(item => {
					if (item.jj != null && item.jj != 0) {
						sku.push({
							spec_sku_id: item.spec_sku_id,
							sku_name: item.sku_name,
							spec_sku_id: item.spec_sku_id,
							sku_name: item.sku_name,
							add_price: item.jj
						})
					} else {
						num++;
					}
				});

				let param = {
					goods_id: that.goodsid,
					store_id: that.store,
					sku: sku,
					sort: that.sort
				}
				if (num > 0) {
					Dialog.confirm({
							title: '温馨提示',
							message: '您有部分产品未加价，是否确认0利润上架该产品？',
						})
						.then(() => {
							//这里直接调用网络接口
							that.commitUp(param)
						})
						.catch(() => {
							// on cancel
						});
					return;
				}
				that.commitUp(param)
			},
			commitUp(param) {
				let that = this
				var url = "/addons/litestore/api.store/productShelves"
				util.post(url, param,function(result) {
				    //return false;
						Toast(result.msg);
            if (result.code){
              setTimeout(() => {
                that.$router.push({
                  path: 'xpsj'
                })
              }, 1000);
            }
					},
				);
			},
			getData() {
				let that = this;
				//util.isToken
				var url = "/addons/litestore/api.store/productShelves"
				//这里直接调用网络接口
				util.get(url, {
						goods_id: that.goodsid,
						store_id: that.store
					},
					function(result) {
						that.goods = result.data
						that.goodsskus = result.data.skus
						that.goodsskus.forEach((value, index) => {
							if (value.store_add_price != null) {
								value['jj'] = value.store_add_price
							} else {
								let ff = value.add_price.split(',')
								// 是否有选中的价格,没有的话默认选中第一个价格
								value['jj'] = ff[0]
							}
							that.showPopover.push(false)
						});
					},
				);
			}
		},
		created() {
			this.store = this.$store.getters.getShop
			this.getData();
		},
		watch: {
			"$store.state.gcfg"() {
				this.gcfg = this.$store.getters.getGcfg
			},
			"$store.state.shop"() {
				this.store = this.$store.getters.getShop
			}
		},
	}
</script>

<style scoped="scoped">
	.content {}

	.van-cell__title {
		color: #969799;
	}

	.van-cell__title .van-cell__label {
		color: #ff0000;
	}

	.van-cell__value {
		color: #000;
	}

	.van-cell__value .van-cell {
		padding: 0;
	}

	.listjg {
		margin-bottom: 80px;
	}

	.listjg .jgtitle {
		padding: 15px;
	}

	.jgitem+.jgitem {
		border-top: 1px solid #dedede;
	}

	.spitem {
		padding: 15px 10px 15px 0;
		display: flex;
		align-items: center;
		box-shadow: 0 0 5px #ebebeb;
		border-radius: 10px;
	}

	.right-content {
		width: 0;
		flex: 1;
		padding-left: 10px;
	}

	.right-content .title {
		font-size: 15px;
		font-weight: 600;
		margin-bottom: 5px;
	}

	.right-content .xse {
		padding: 2px 0;
		font-size: 13px;
		color: #999999;
	}

	.right-content .xse .price {
		padding: 0 5px;
		color: #ff0000;
		font-size: 16px;
		font-weight: 600;
	}

	.leftimg {
		/* width: 120px; */
		height: 120px;
	}
</style>
